var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"timeline"},_vm._l((_vm.items),function(item,index){return _c('TimelineItem',{key:item.id || index,attrs:{"item":item,"item-type":_vm.itemType}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }